module.exports = __webpack_public_path__ + "files/1dbec61e90233bdb11405f5ead0da938.png";